module.exports = __webpack_public_path__ + "media/images/dashboard_icons/service_charge-018832069b1842c4dc9e117872e6cb07.svg";